import type { SVGProps } from 'react';
const SvgIconShield = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      d="M10.988 7.206a.75.75 0 1 0-1.061-1.061l-2.12 2.119L6.57 7.027a.75.75 0 0 0-1.06 1.06l1.767 1.768a.75.75 0 0 0 1.061 0z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.533.883a1.75 1.75 0 0 0-1.066 0L2.724 2.401A2.25 2.25 0 0 0 1.18 4.853l.757 5.45a4.75 4.75 0 0 0 2.94 3.756l2.472.989a1.75 1.75 0 0 0 1.3 0l2.472-.989a4.75 4.75 0 0 0 2.94-3.757l.757-5.449a2.25 2.25 0 0 0-1.543-2.452zm-.61 1.429a.25.25 0 0 1 .153 0L12.82 3.83a.75.75 0 0 1 .515.817l-.757 5.449a3.25 3.25 0 0 1-2.012 2.57l-2.472.99a.25.25 0 0 1-.186 0l-2.472-.99a3.25 3.25 0 0 1-2.012-2.57l-.756-5.449a.75.75 0 0 1 .514-.817z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIconShield;
